<div class="text">
    <h4>{{ label }}</h4>

    <span class="total">{{ total }}</span>
</div>
